<template>
  <div class="continer">
    <div class="content">
      <p>
        <span>友情链接:</span>
        <a href="http://www.mohurd.gov.cn/">中华人民共和国住房和城乡</a>
        <a href="http://www.pqrc.org.cn/">住房和城乡建设部执业资格</a>
        <a href="http://www.nmkcsj.org.cn/Index">内蒙古勘察设计网</a>
        <a href="http://www.pqrc.org.cn/Subpage/RegisterQuery.aspx">注册查询</a>
      </p>
      <p>
        <span>电话:</span><em>0475-6336566</em>
        <span>传真:</span><em>0475-6185518</em>
        <span>监督电话:</span><em>0475-6185518</em>
        <span>地址:</span><em>通辽市霍林河大街58号</em>
      </p>
      <p>内蒙古通辽大地建设工程施工图审查有限责任公司
        .版权所有 tldayou.cn copyright(c) 2011. 
        TLdayou. All Right Reserved. <span class="clickspan" @click="changeUrl">蒙ICP备2020004818号-1</span></p>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    changeUrl () {
      window.open('https://beian.miit.gov.cn')  
    }
  },
}
</script>
<style lang="stylus" scoped>
.continer
  height 218px
  width 100%
  background #2d2f33
  .content
    width 1200px
    margin 0  auto
    padding 48px 0 0 30px
    box-sizing border-box
    p 
      color #fff
      margin-bottom 20px
      span 
        margin-right 10px
      .clickspan
        cursor pointer
        &:hover
          color #016bff
      a 
        color #3377FF
        margin-right 30px
      em 
        margin-right 50px
</style>
